// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17L3i","placeholdersHeader":"styles_placeholdersHeader__WkAzK","editorStyle":"styles_editorStyle__1_qYm","placeholdersBox":"styles_placeholdersBox__1KYtq"};